import React, { forwardRef } from 'react';
import { Input } from '../Input';
import { IInputProps } from '../models';

export interface IInputPasswordProps extends IInputProps {}

/** Поле ввода пароля */
export const InputPassword = forwardRef<HTMLInputElement, IInputPasswordProps>((props, ref) => (
  <Input password={true} {...props} ref={ref} />
));

InputPassword.displayName = 'InputPassword';
